import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

// Define the API URL
const API_URL = "https://api.recdbase.org/comment/create";

// Async Thunk for posting a comment
export const postComment = createAsyncThunk(
  "comments/postComment",
  async ({ resource_id, parent_id, content, token }, { rejectWithValue }) => {
    try {
      const response = await axios.post(
        API_URL,
        { resource_id, parent_id, content },
        {
          headers: {
            Authorization: `Bearer ${token}`, // Attach token
            "Content-Type": "application/json",
          },
        }
      );
      console.log(response.data);
      
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

export const fetchComments = createAsyncThunk(
  "resource/fetchComments",
  async (resourceId, { rejectWithValue }) => {
    try {
      const response = await axios.get(
        `https://api.recdbase.org/comment/get/${resourceId}`
      );
      return response.data;
    } catch (error) {
      return rejectWithValue(error.response?.data || "Something went wrong");
    }
  }
);

const commentSlice = createSlice({
  name: "comments",
  initialState: {
    comments: [],
    status: "idle",
    success: "",
    messageData: null,
    error: null,
  },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(postComment.pending, (state) => {
        state.status = "loading";
      })
      .addCase(postComment.fulfilled, (state, action) => {
        state.status = "succeeded";
        state.success =action.payload;
        state.messageData = action.payload.message
      })
      .addCase(postComment.rejected, (state, action) => {
        state.status = "failed";
        state.error = action.payload;
      });

      builder
      .addCase(fetchComments.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchComments.fulfilled, (state, action) => {
        state.loading = false;
        state.comments = action.payload;
      })
      .addCase(fetchComments.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload;
      });
  },
});

export default commentSlice.reducer;
